var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-setting"},_vm._l((_vm.settings),function(item,index){return _c('basic-setting',{key:index,staticClass:"basic-item",attrs:{"config":typeof item === 'string' ? item : item.name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }